import * as localforage from "localforage";

export enum SYSTEM_CACHE_TYPE {
  SAVE,
  REMOVE,
  GET,
}

export interface ICacheResp {
  _Date?: Date;
  _Data?: any;
}

export class CacheSystem {
  static HandleSystemCaching(
    Type: SYSTEM_CACHE_TYPE,
    Name: string,
    Data: any = null
  ): ICacheResp {
    let name = Name.toUpperCase();

    switch (Type) {
      case SYSTEM_CACHE_TYPE.GET:
        return this.GetCacheData(name);
        break;

      case SYSTEM_CACHE_TYPE.SAVE:
        return this.SaveData(name, Data);
        break;

      case SYSTEM_CACHE_TYPE.REMOVE:
        return this.RemoveData(name);
        break;

      default:
        break;
    }
  }

  static SaveData(Name: string, Data: any) {
    const DefaultCacheResp: ICacheResp = {
      _Date: null,
      _Data: false,
    };

    try {
      if (Data !== null) {
        const CacheResp: ICacheResp = {
          _Date: new Date(),
          _Data: Data,
        };
        localforage.setItem(Name, JSON.stringify(CacheResp));
        DefaultCacheResp._Data = true;
      }

      return DefaultCacheResp;
    } catch (error) {
      return DefaultCacheResp;
    }
  }

  static RemoveData(Name: string) {
    var DefaultCacheResp: ICacheResp = {
      _Date: null,
      _Data: false,
    };

    try {
      localforage.removeItem(Name);
      DefaultCacheResp._Data = true;
      return DefaultCacheResp;
    } catch (error) {
      return DefaultCacheResp;
    }
  }

  static GetCacheData(Key: string): ICacheResp {
    const CachedData = localStorage.getItem(Key);
    if (CachedData) {
      return JSON.parse(CachedData) as ICacheResp;
    }
    const DefaultCacheResp: ICacheResp = {
      _Date: null,
      _Data: null,
    };
    return DefaultCacheResp;
  }

  static CacheData(Key: string, Data: any) {
    let key = Key.toUpperCase();
    if (Data !== null) {
      const cacheResp: ICacheResp = {
        _Date: new Date(),
        _Data: Data,
      };
      localforage.setItem(key, cacheResp);
    }
  }

  static async GetCacheDataV2(Key: string): Promise<any> {
    let key = Key.toUpperCase();
    try {
      const cachedData = await localforage.getItem<ICacheResp>(key);
      if (cachedData) {
        return cachedData;
      }
    } catch (error) {
      console.error("Error retrieving cache data:", error);
    }
    return JSON.stringify({
      _Date: null,
      _Data: null,
    });
  }

  static async GetCacheDataV1(Key: string): Promise<ICacheResp> {
    let key = Key.toUpperCase();
    try {
      const cachedData = await localforage.getItem<ICacheResp>(key);
      if (cachedData) {
        return cachedData;
      }
    } catch (error) {
      console.error("Error retrieving cache data:", error);
    }
    return {
      _Date: null,
      _Data: null,
    };
  }
}

export const CACHE_KEYs = {
  DOORS: "DOORS",
  WEEKLY_PROGRAM: "WEEKLY_PROGRAM",
  TIMETABLE: "TIMETABLE",
  TIMEZONE: "TIMEZONE",
  TIMESHIFT: "TIMESHIFT",
  DOOR_PROGRAM: "DOOR_PROGRAM",
  SERVICES: "SERVICES",
  ACCESSPOINTS: "ACCESSPOINTS",
  AP_GROUP: "ACCESSPOINT_GROUP",
  DOOR_EVENTS: "DOOR_EVENTS",
  DASHBOARD_SUMMARY: "DASHBOARD_SUMMARY",
  DASHBOARD_SKYACCESS: "DASHBOARD_SKYACCESS",
  DASHBOARD_DEFAULT: "DASHBOARD_DEFAULT",
  ACCESS_CARD: "ACCESS_CARD",
  DOORS_FOR_WIRELESS_CHART: "DOORS_FOR_WIRELESS_CHART",
  BATTERY_CHART: "BATTERY_CHART",
  SUPPORT_TICKETS: "SUPPORT_TICKETS",
  CALENDER_DSD: "CALENDER_DSD",
  ACCESS_RIGHT: "ACCESS_RIGHT",
  ACCESS_PROFILE: "ACCESS_PROFILE",
  ACCESS_PERSON: "ACCESS_PERSON",
  DATABASE_BACKUP: "DATABASE_BACKUP",
  DATABASE_RESTORE: "DATABASE_RESTORE",
  ENCODER: "ENCODER",
  PMS_LOGS: "PMS_LOGS",
};
